import "./skip-link.css";

export function SkipLinkFocus(props: {label: string, target: string}){
  return <button 
    className="skip" 
    onClick={()=>{
      let next_element = document.getElementById(props.target);
            
      if (!next_element || next_element.attributes["inert"]){ return; }

      if (!next_element.attributes || !('tabindex' in next_element!.attributes)) {
          if (props.last_element){
            let elements = next_element?.querySelectorAll("select, textarea, input, button");
            next_element = elements[elements.length-1];
          }else{
            next_element = next_element?.querySelector("select, textarea, input, button");
          }
      }

      if (!next_element || next_element.attributes["inert"]){ return; }
      setTimeout(() => {
          next_element.focus();
      }, 100);
    }}
    ><span>{props.label}</span></button>;
}